import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Message} from "primeng/api";
import {UserData} from "../../../interfaces";
import {LocalStorageKey, Permission} from "../../../enums";
import {LocalStorageService} from "library";

@Component({
  selector: 'app-commission-reports',
  templateUrl: './commission-reports.component.html',
  styleUrls: ['./commission-reports.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommissionReportsComponent implements OnInit{
  titleBreadcrumbs = 'Reportes'
  selectedDate = new Date();
  activatedTab: number | null = 0;
  year!: number;
  month!: number;
  messagesSale: Message[] = [];
  messagesCommissions: Message[] = [];
  messagesPayments: Message[] = [];
  messagesCancelattions: Message[] = [];
  onListSale: any[] = [];
  onListCommissions: any[] = [];
  onListPayments: any[] = [];
  onListCancellations: any[] = [];
  userData: UserData;
  storeID? : string;
  textColor?: string;
  textColorSecondary?: string;
  surfaceBorder? : string;

  constructor( private localStorageService: LocalStorageService) {
    this.setDate(this.selectedDate);
    this.userData = this.localStorageService.get(LocalStorageKey.data);
    this.storeID = this.userData.store?.id;
    console.log(this.userData);
  }
  ngOnInit() {
    const documentStyle = getComputedStyle(document.documentElement);
    this.textColor = documentStyle.getPropertyValue('--text-color');
    this.textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    this.surfaceBorder = documentStyle.getPropertyValue('--surface-border');
  }

  setDate(date: Date) {
    this.month = new Date(date).getMonth() + 1;
    this.year = new Date(date).getFullYear();
  }

  onChangeDate($event: any) {
    const actived = this.activatedTab;
    this.activatedTab = null;
    this.setDate($event);
    setTimeout(() => this.activatedTab = actived, 0);
  }
  onReceiveEvent(type: string, list: any) {
    switch (type) {
      case 'sales':
        this.onListSale = list;
        this.messagesSale = [
          { severity: 'warn', detail: ' No se encontrarón ventas para este periodo de tiempo' },
        ];
        break;
      case 'commissions':
        this.onListCommissions = list;
        this.messagesCommissions = [
          { severity: 'warn', detail: ' No se encontrarón comisiones para este periodo de tiempo' },
        ];
        break;
      case 'payments':
        this.onListPayments = list;
        this.messagesPayments = [
          { severity: 'warn', detail: ' No se encontrarón pagos para este periodo de tiempo' },
        ];
        break;
      case 'cancellations':
        this.onListCancellations = list;
        this.messagesCancelattions = [
          { severity: 'warn', detail: ' No se encontrarón anulaciones para este periodo de tiempo' },
        ];
        break;
      default:
        console.error('Tipo de lista no reconocido');
    }
  }

  protected readonly Permission = Permission;
}
